var _a;
export var ALL = 'Összes';
export var TEAM = 'Csapatom';
export var MINE = 'Sajátom';
var taskFilter = (_a = {},
    _a[ALL] = function (task, store) { return true; },
    _a[TEAM] = function (task, store) { return task.tasks.some(function (x) { return store.employees.indexOf(x.userId) >= 0; }); },
    _a[MINE] = function (task, store) { return task.tasks.some(function (x) { return x.userId === store.userId; }); },
    _a);
export function getNfcViewOptions() {
    return [ALL, TEAM, MINE];
}
export function getNfcViewOptionFilter(type) {
    return taskFilter[type] || taskFilter[ALL];
}



//////////////////
// WEBPACK FOOTER
// ./src/pages/nfctask/NfcTaskViewOptions.tsx
// module id = 377
// module chunks = 0